module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }